module.exports = "dist/images/components-design-separator-control-wave-4.5f9e008.png";